import { Paper, Stack, useTheme } from '@mui/material'

import { getMessageColors } from '~/features/chatbot/components/message/utils'
import { TPreChatFormSubmissionPayload } from '~/features/chatbot/models'
import FormSubmissionFields from '~/features/preChatForms/components/formSubmissionFields'
import { ETestId } from '~/models/tests'
import { store } from '~/store'
import rem from '~/utils/ui'

type TProps = {
  data: TPreChatFormSubmissionPayload
}

function PreChatFormSubmissionMessage({ data }: TProps) {
  const [chatbotLayout] = store((state) => [state.chatbot.layout])
  const theme = useTheme()
  const { userColor, userBackgroundColor } = getMessageColors(
    chatbotLayout,
    theme,
  )

  return (
    <Stack
      alignItems="flex-start"
      data-testid={ETestId.ChatMessageUser}
      sx={{
        alignSelf: 'flex-end',
        maxWidth: '70%',
      }}
      useFlexGap
    >
      <Paper
        variant="outlined"
        sx={{
          '&.MuiPaper-root': {
            borderRadius: rem(16),
          },
          p: 1,
          width: 'fit-content',
          minWidth: rem(160),
          maxWidth: '100%',
          overflowWrap: 'break-word',
          wordWrap: 'break-word',
          color: userColor,
          backgroundColor: userBackgroundColor,
        }}
      >
        <FormSubmissionFields
          fields={data.fields}
          labelColor={userColor}
          missingValueColor={userColor}
          valueColor={userColor}
        />
      </Paper>
    </Stack>
  )
}

export default PreChatFormSubmissionMessage
